export default __webpack_public_path__ + "static/media/insure-tech.c8c39906.svg";